import Error404Img from '../../assets/app/error-404-not-found.png'

const Error404 = () => {
    
    return <div className='flex items-start justify-center opacity-60'>
        <img src={Error404Img} className='max-h-[80vh]' />
    </div>
}
export {Error404}